<template>
  <div id="app">

    <audio preload="auto" :src="mixlr.src" ref="mixlr" />
    <audio preload="auto" :src="airTime.src" ref="airTime" />

    <div class="channel">
      <div class="channel__top">
        <div class="channel__name text-serif">#RFSC #OFFICIAL</div>
        <a @click="toggleMixlr" class="channel__play text-serif" v-if="mixlr.onAir">
          <span v-if="mixlr.playing">STOP</span>
          <span v-if="!mixlr.playing">PLAY</span>
        </a>
        <a class="channel__play channel__play--off-air text-serif" v-if="!mixlr.onAir">
          OFF AIR
        </a>
      </div>
      <div class="channel__info" v-if="mixlr.onAir">
        <marquee-text :repeat="5">
          <div class="player__info-text" v-html="mixlr.text + ''" />
        </marquee-text>
      </div>
    </div>


    <div class="channel">
      <div class="channel__top">
        <div class="channel__name text-serif">
          <a href="https://www.radio-bollwerk.ch" target="_blank">RADIO BOLLWERK</a>
        </div>
        <a @click="toggleAirTime" class="channel__play text-serif">
          <span v-if="airTime.playing">STOP</span>
          <span v-if="!airTime.playing">PLAY</span>
        </a>
      </div>
      <div class="channel__info">
        <marquee-text :repeat="5">
          <div class="player__info-text" v-html="airTime.text + ' '" />
        </marquee-text>
      </div>
    </div>

  </div>
</template>

<script>
  import Api from './api.js';
  import MarqueeText from 'vue-marquee-text-component'

export default {
  name: 'App',

  data() {
    return {
      mixlr: {
        onAir: false,
        text:  '',
        playing: false,
        src: 'http://edge.mixlr.com/channel/whcwq'
      },
      airTime: {
        onAir: true,
        text:  '',
        playing: false,
        src: 'https://radiobollwerk.out.airtime.pro/radiobollwerk_a'
      }
    }
  },

  mounted() {
    window.setInterval(this.getInfos.bind(this), 30000)

    this.getInfos();
  },

  methods: {

    toggleMixlr() {
      this.mixlr.playing ? this.stopMixlr() : this.playMixlr()
    },

    toggleAirTime() {
      this.airTime.playing ? this.stopAirTime() : this.playAirTime()
    },

    playMixlr() {
      this.stopAirTime(),
      this.mixlr.playing = true;
      this.$refs.mixlr.play();
    },

    stopMixlr() {
      try {
        this.mixlr.playing = false;
        this.$refs.mixlr.pause();
        this.$refs.mixlr.currentTime = 0;
      } catch (e) {
        console.error(e)
      }
    },

    playAirTime() {
      try {
        this.stopMixlr();
        this.airTime.playing = true;
        this.$refs.airTime.play();
      } catch (e) {
        console.error(e)
      }
    },

    stopAirTime() {
      try {
        this.airTime.playing = false;
        this.$refs.airTime.pause();
        this.$refs.airTime.currentTime = 0;
      } catch (e) {
        console.error(e)
      }
    },

    async getInfos() {
      try {
        this.getMixlrInfo()
        this.getAirTimeInfo()
      } catch (e) {
        console.error(e)
      }
    },

    async getAirTimeInfo() {
      try {
        const data = await Api.getAirTimeInfo();

        this.airTime.text = data.text;
      } catch (e) {}
    },

    async getMixlrInfo() {
      try {
        const data = await Api.getMixlrInfo();

        console.log(data)

        this.mixlr.onAir = data.onAir
        this.mixlr.text = data.text;

        if (!this.mixlr.onAir && this.mixlr.playing) {
          this.stopMixlr();
        }
      } catch (e) {}
    }
  },

  components: {
    MarqueeText
  }

}
</script>

<style lang="scss">

  $color-a: #e0e0e0;
  $color-b: #fefc09;
  $color-c: black;
  $shadow: 2px 2px 0;
  $border: 2px solid $color-c;

  @import "https://cdnjs.cloudflare.com/ajax/libs/normalize/8.0.1/normalize.min.css";

  @font-face {
    font-family: 'RFSC Sans';
    src: url('../public/rfsc-sans.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'RFSC';
    src: url('../public/rfsc.otf') format('opentype');
    font-weight: 300;
    font-style: normal;
  }

  html, body {
    margin: 0;
    padding: 0;
  }

  body {
    font-family: 'RFSC Sans', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: $color-a;
    font-size: 20px;
  }

  button {
    border: none;
    background: transparent;
  }

  .text-serif {
    font-family: 'RFSC', sans-serif;
  }

  .channel {
    margin: 0 0 24px 0;
    border: $border;
    margin-bottom: 60px;
  }

  .channel__top {
    font-size: 32px;
    background: $color-a;
    display: flex;

    > div, > a {
      display: flex;
      justify-items: center;
      align-items: center;
    }

    @media screen and (min-width: 600px) {
      font-size: 48px;
    }
  }

  .channel__info {
    padding: 8px;
    border-top: $border;
  }

  .channel__name {
    width: calc(100% - 140px);
    padding: 8px;
    text-shadow: $shadow $color-b;

    a {
      color: currentColor;
      text-decoration: none;
    }

  }

  .channel__play {
    width: 140px;
    padding: 8px;
    text-align: center;
    cursor:pointer;
    align-content: center;
    justify-content: center;

    color: $color-b;
    text-shadow: $shadow $color-c;
    border-left: $border;

    &:hover,
    &:focus {
      color: $color-c;
      text-shadow: $shadow $color-b;
    }
  }

  .player__info-text {
    display: inline-block;
    padding-right: 16px;
    line-height: 1.5;
  }

  .channel__play--off-air {

    font-size: 28px;
  }

</style>
